import { render, staticRenderFns } from "./BoxUserGroupManagementSettings.vue?vue&type=template&id=48be5489&"
import script from "./BoxUserGroupManagementSettings.vue?vue&type=script&lang=js&"
export * from "./BoxUserGroupManagementSettings.vue?vue&type=script&lang=js&"
import style0 from "./BoxUserGroupManagementSettings.vue?vue&type=style&index=0&id=48be5489&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BoxUserGroupManagementSettings.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxUserGroupManagementSettings.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QForm,QInput,QIcon,QOptionGroup,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QForm,QInput,QIcon,QOptionGroup,QBtn,QInnerLoading,QSpinnerTail})
